export const SHOP_SOURCE = {
  YESCLOUD: 'yescloud',
  API: 'API',
};

export const STORAGE_KEY = {
  CART: 'cart',
  CUSTOMER_ID: 'customer-id',
  PROFILE: 'profile',
  CUSTOMER_DETAILS: 'customer-details',
  ORDERS: 'orders',
  PAYMENT_ID: 'payment-id',
  PAYMENT_SECRET: 'payment-secret',
  SHOP_ID: 'shop-id',
  LAST_PAYMENT: 'last-payment',
  PAYMENTS: 'payments',
  TOKEN: 'token',
};

export const SERVER = {
  // Using localhost:8000 to test the local backend changes
  // URL: process.env.REACT_APP_API_BASE_URL || 'http://localhost:8000',
  URL: process.env.REACT_APP_API_BASE_URL || 'https://api-pos-legacy-uat.sanoft.com',
};

export const DEFAULT_CURRENCY = 'Rs';

export const ROUTES = {
  SHOP_HOME: '/:shopId',
  PROFILE: '/:shopId/profile',
  ORDER_DETAILS: '/:shopId/orders/:orderId',
  PAYMENT_STATUS: '/:shopId/payment-status',
  CART: '/:shopId/cart',
  PRODUCT_DETAILS: '/:shopId/products/:categoryId/:productId',
  CONTACT_US: '/:shopId/contact-us',
  CUSTOMER_DETAILS: '/:shopId/customer-details',
  PIVACY_POLICY: '/:shopId/privacy-policy',
  TERMS_AND_CONDITIONS: '/:shopId/terms-conditions',
  REFUND_POLICY: '/:shopId/refund-policy',
  SHIPPING_POLICY: '/:shopId/shipping-policy',
  SANOFT_CONTACT_US: '/:shopId/sanoft-contact-us',
  PAYMENT_CALLBACK: '/:shopId/payment-callback',
};

export const DEFAULT_HOST = 'cart.sanoft.com';

export const SHOP_MODE = {
  VIEW_ONLY: 'VIEW_ONLY',
};

export const PRODUCT_TYPES = {
  SERVICE: 'SERVICE',
};

export const DEFAULT_CONFIG = {
  name: 'SANOFT',
  shopId: null,
  theme: {
    primary: '#272C86',
    secondary: '#1F236B',
    tertiary: '#9DA2FF',
  },
  config: {
    currency: '₹',
    mobile: '9746393923',
    email: 'admin@sanoft.com',
    address: 'B Block, 2nd Floor, KKM City Centre, Areekode',
    location: 'Areekode, Kerala',
  },
};

export const MAX_API_CALLS_FOR_POLLING = 60;

export const TIME_OUT_MESSAGE = 'Payment failed. If payment is deducted, please contact the counter.';

export const QR_URL = 'https://qr.sanoft.com/oo?d=';

export const QR_PREFIX = 'oo:';

export const SANOFT_WEB_URLS = {
  PRIVECY_POLICY: 'https://www.sanoft.com/privacy-policy',
  TERMS_AND_CONDITIONS: 'https://www.sanoft.com/terms-and-conditions',
  REFUND_POLICY: 'https://www.sanoft.com/refund-policy',
  CONTACT_US: 'https://www.sanoft.com/#contact-us',
};

export const ORDER_STATUS = {
  PENDING: 'PENDING',
  DELIVERED: 'DELIVERED',
};

export const ORDER_TYPE = {
  default: [
    {
      id: 'name',
      label: 'Name',
      order: 1,
      type: 'text',
      placeholder: 'Enter name',
      required: true,
      editable: true,
    },
    {
      id: 'mobile',
      label: 'Mobile',
      placeholder: 'Enter mobile number',
      order: 2,
      type: 'tel',
      required: true,
      editable: true,
    },
  ],
  home: [
    {
      id: 'name',
      label: 'Name',
      order: 1,
      type: 'text',
      placeholder: 'Enter name',
      required: true,
      editable: true,
    },
    {
      id: 'mobile',
      label: 'Mobile',
      placeholder: 'Enter mobile number',
      order: 2,
      type: 'tel',
      required: true,
      editable: true,
    },
    {
      id: 'address',
      label: 'Address',
      placeholder: 'Enter address',
      order: 3,
      type: 'text',
      required: false,
      editable: true,
    },
    {
      id: 'landmark',
      label: 'Landmark',
      placeholder: 'Enter landmark (optional)',
      order: 4,
      type: 'text',
      required: false,
      editable: true,
    },
  ],
  'drive-through': [
    {
      id: 'car_name',
      label: 'Car Name',
      order: 1,
      type: 'text',
      required: true,
      editable: true,
    },
    {
      id: 'car_model',
      label: 'Car Model',
      order: 2,
      type: 'text',
      required: true,
      editable: true,
    },
    {
      id: 'name',
      label: 'Name',
      order: 3,
      type: 'text',
      required: true,
      editable: true,
    },
    {
      id: 'mobile',
      label: 'Mobile',
      order: 4,
      type: 'tel',
      required: true,
      editable: true,
    },
  ],
  table: [
    {
      id: 'table',
      label: 'Table',
      order: 1,
      type: 'text',
      required: true,
      editable: false,
    },
    {
      id: 'name',
      label: 'Name',
      order: 2,
      type: 'text',
      required: false,
      editable: true,
    },
    {
      id: 'mobile',
      label: 'Mobile',
      order: 3,
      type: 'tel',
      required: false,
      editable: true,
    },
  ],
  theatre: [
    {
      id: 'name',
      label: 'Name',
      order: 1,
      type: 'text',
      required: true,
      editable: true,
    },
    {
      id: 'mobile',
      label: 'Mobile',
      order: 2,
      type: 'text',
      required: true,
      editable: true,
    },
    {
      id: 'screen',
      label: 'Screen No',
      order: 3,
      type: 'text',
      required: false,
      editable: true,
    },
    {
      id: 'seat',
      label: 'Seat No',
      order: 4,
      type: 'text',
      required: false,
      editable: true,
    },
  ],
};

export const STOCK_STATUS = {
  sold_out: {
    label: 'Sold Out',
    color: '#ff0000',
    backgroundColor: '#FFDEDE',
  },
  on_hold: {
    label: 'On hold',
    color: '#ff8b00',
    backgroundColor: '#FDE5C8',
  },
};

export const PAYMENT_TYPE = {
  NO_PAYMENT: 'NO_PAYMENT',
};

export const QUERY_PARAM_PIEFIX_KEY = 'query_params_prefix';

export const QUERY_PARAM_TIMEOUT = 24 * 60 * 60 * 1000;

export const PAYMENT_STATUS = {
  PENDING: 'PENDING',
  SUCCESS: 'SUCCESS',
  FAILED: 'FAILED',
  REFUND_SUCCESS: 'REFUND-SUCCESS',
  REFUND_FAILED: 'REFUND-FAILED',
};

export const POPUP_ROUTES = [
  ROUTES.SHOP_HOME,
  ROUTES.CART,
  ROUTES.CUSTOMER_DETAILS,
  ROUTES.PRODUCT_DETAILS,
  ROUTES.PROFILE,
];
